export const OriginatorRelationshipValueOptions: {type: OriginatorRelationshipValue, name: string}[] = [
  {type: 'disclosed', name: 'Disclosed'},
  {type: 'undisclosed', name: 'Undisclosed'},
];

export type OriginatorRelationshipValue = 'disclosed' | 'undisclosed' | null;
